import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { darkModeAware, withStyles } from '@glu/theming';
import { CaretDownIcon } from '@glu/icons-react';
import styles from './SelectBase.styles';

let uniqueId = 0;

const SelectBase = ({
  htmlId,
  name,
  className,
  value,
  onChange,
  firstOption,
  children,
  classes,
  warning,
  /** These shouldn't be passed in as a prop to select. underscore indicates not used */
  dark: _dark,
  theme: _theme,
  ...rest
}) => {
  // eslint-disable-next-line no-plusplus
  const id = useMemo(() => htmlId || `input-${uniqueId++}`, [htmlId]);
  return (
    <div className={`${classes.root} ${className}`}>
      <select
        id={id}
        className={`${classes.select}`}
        name={name}
        onChange={onChange}
        value={value !== undefined && value !== null ? value : ''}
        {...rest}
      >
        {firstOption}
        {children}
      </select>
      <CaretDownIcon noIconWrapper focusable={false} />
      <span className={`${classes.caret}`} />
    </div>
  );
};

SelectBase.propTypes = {
  /** Name to use for the select */
  name: PropTypes.string,

  /** Html id to use for the select */
  htmlId: PropTypes.string,

  /** ClassName to use for the root element of this component, a wrapper div */
  className: PropTypes.string,

  /** called whenever onChange happens on the select */
  onChange: PropTypes.func.isRequired,

  /** Content for the first option, including the <option> tag set null/false to not use */
  firstOption: PropTypes.node,

  /** Value of currently selected option */
  value: PropTypes.string,

  /** True if the select should be in dark mode which styles it for dark colored forms */
  dark: PropTypes.bool,

  children: PropTypes.node.isRequired,

  /** JSS theme */
  theme: PropTypes.shape({}).isRequired,

  /** Classes for JSS styling */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /** Use warning styles for error if true */
  warning: PropTypes.bool
};

SelectBase.defaultProps = {
  name: undefined,
  htmlId: '',
  className: '',
  firstOption: <option value="" />, // eslint-disable-line jsx-a11y/control-has-associated-label
  value: undefined,
  dark: false,
  warning: false
};

export { SelectBase as BareSelect };
export default darkModeAware(withStyles(styles)(SelectBase));
